import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import Button from '../../../App/Components/Button/Button'
import TextInput from '../../../App/Components/Form/TextInput/TextInput'
import Modal from '../../../App/Components/Modal/Modal'
import { useAppDispatch, useAppSelector } from '../../../App/Hooks/reduxHooks'
import { SurveyObject } from '../Client/ISurvey'
import { addSurvey } from '../Store/Action'
import listStyle from '../style/surveyOverview.scss'

type ListProps = {
  surveyData: SurveyObject[]
}

const SurveyOverviewList = ({ surveyData }: ListProps) => {
  const { t } = useTranslation()

  return (
    <ul className={listStyle.taskItems}>
      {surveyData.map(item => {
        const surveyId = item.id
        return (
          <Link
            to={`surveys/${surveyId}/preview`}
            className={`${listStyle.item}`}
            key={`liFor ${surveyId}`}>
            <div className={listStyle.task}>
              <div className={listStyle.name}>
                <p>{item.name}</p>
              </div>
              <small style={{ marginLeft: '1em' }}>
                {t('locale.' + item.language)}
              </small>
            </div>
            <div className={listStyle.linkArrow}>
              <FontAwesomeIcon
                icon={faAngleRight as IconProp}
                className={listStyle.faIcon}
              />
            </div>
          </Link>
        )
      })}
    </ul>
  )
}

export const SurveyOverview = () => {
  const [modalState, setModalState] = useState<boolean>(false)
  const { t } = useTranslation()

  const dispatch = useAppDispatch()

  const establishment = useAppSelector(state => state.establishment)
  const surveys = useAppSelector(state => state.customers.surveys.list)

  const makeNewSurvey = () => {
    const inputFields = document
      .getElementById('makeSurveyInput')
      .getElementsByTagName('input')
    const arrayOfFieldValues: string[] = []
    let i
    for (i = 0; i < 3; i++) {
      const checkForVal = /\S/.test(inputFields[i].value)
      if (checkForVal) {
        arrayOfFieldValues[i] = inputFields[i].value
      } else {
        alert(t('Both fields should contain a value'))
        return
      }
    }

    dispatch(
      addSurvey({
        name: arrayOfFieldValues[0],
        description: arrayOfFieldValues[1],
        mailSubject: arrayOfFieldValues[2],
        establishmentId: establishment.active?.id as number,
      }),
    )
    setModalState(false)
  }
  return (
    <div className={'page-layout'}>
      <Modal
        modalState={modalState}
        extraWidth={'60vw'}
        setModalState={state => setModalState(state)}
        modalTitle={t('Create new survey')}>
        <div id={'makeSurveyInput'}>
          <TextInput label={t('Name')} isRequired />
          <TextInput label={t('Description')} isRequired />
          <TextInput label={t('Mail Subject')} isRequired={false} />
        </div>
        <Button onClick={() => makeNewSurvey()}>{t('Create')}</Button>
      </Modal>
      {surveys.length === 0 ? (
        <p>{t('No surveys found')}</p>
      ) : (
        <SurveyOverviewList surveyData={surveys} />
      )}
      <Button onClick={() => setModalState(true)}>{t('Add Survey')}</Button>
    </div>
  )
}
